<template>
  <div class="container__left">
    <AmCard class="container__left__card">
      <AmSteps
        ref="steps"
        v-model="currentStep"
        class="steps"
        :steps="steps"
        hide-previous
        hide-next
      >
        <template>
          <div
            :class="{ steps__payment: currentStep === 2 }"
            class="routerComponent"
            @keyup.enter="actionsPostSteps()"
          >
            <router-view
              ref="routerComponent"
              v-model="stepsData.payment"
              :shippingData="stepsData.shipping"
              :selectedComponent="currentStep"
              :installmentSelected="stepsData.payment.installments"
              :paymentType="currentPaymentTypeSelected"
              :creditCardFlag="creditCardFlag"
              :creditCardLastDigits="creditCardLastDigits"
              @reviewEditAdress="reviewEditAdress"
              @reviewEditContact="reviewEditContact()"
              @searchCep="getCep"
              @paymentSelected="paymentSelected"
              @paymentCardFinishPayment="paymentCardFinishPayment()"
              @refreshCodePix="paymentForPix()"
              @continuePaymentCard="continuePaymentCard()"
              @continueToPaymentType="continueToPaymentType()"
              @returnFromOrderBump="returnFromOrderBump()"
              @returnPaymentCardDataPayment="returnPaymentCardDataPayment()"
              @returnPaymentTypeErrorBilletOrPix="returnPaymentType()"
              @returnWithRecaptchaAttemptsCount="recaptchaAttemptsCount()"
            />
            <div
              v-show="specialCreditCardStep && hideNextStep"
              class="payment__button"
            >
              <AmButton
                v-if="hideButtonActionPayment"
                data-test="payment"
                :class="['next', disabledNextStep ? '' : theme.color]"
                :label="labelButtonPayment"
                size="xl"
                full-width
                :icon="iconPayment"
                :disabled="loadingGlobal"
                @click="paymentTypeSelectedAction"
              >
                <template
                  v-if="loadingGlobal"
                  #content
                >
                  <AmLoading
                    class="loading--white"
                    :AmLoaderSize="35"
                  />
                </template>
              </AmButton>
            </div>
          </div>
          <AmTypography
            v-show="hideNextStep && !hideReturnStepPayment"
            :class="`steps__change-payment text--${theme.color}`"
            typography-style="l5"
          >
            <template #default>
              <div
                data-test="return_payment"
                class="steps__change-payment__return"
                @click="returnPayment()"
              >
                {{ $t('return') }}
              </div>
            </template>
          </AmTypography>
        </template>
        <template
          v-if="hiddenButtonInProgress"
          #footer
        >
          <!-- Button First view -->
          <AmButton
            v-show="!hideNextStep"
            ref="defaultCheckoutButton"
            data-test="next_step"
            :label="$t('steps.nextStep')"
            :class="['next', disabledNextStep ? '' : theme.color]"
            size="xl"
            full-width
            :icon="iconNext"
            :disabled="disabledNextStep"
            @click="actionsPostSteps()"
          >
            <template
              v-if="loadingGlobal"
              #content
            >
              <AmLoading
                class="loading--white"
                :AmLoaderSize="35"
              />
            </template>
          </AmButton>
          <AmTypography
            v-if="returnStepShowText() && !hideNextStep"
            :class="`steps__return-step text--${theme.color}`"
            typography-style="l5"
          >
            <template #default>
              <div
                class="steps__return-step__return"
                @click="returnStep()"
              >
                {{ returnStepText }}
              </div>
            </template>
          </AmTypography>
        </template>
      </AmSteps>
    </AmCard>

    <AmFooter />
  </div>
</template>

<script>
import replaceSpecialCharactersMixin from '@/components/mixins/replaceSpecialCharactersMixin'
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapMutations, mapActions, mapState } from 'vuex'
import AmSteps from '@/components/molecules/AmSteps.vue'
import AmFooter from '../AmFooter/AmFooter.vue'

export default {
  name: 'ContainerLeft',
  components: {
    AmSteps,
    AmFooter,
  },
  mixins: [themeMixin, replaceSpecialCharactersMixin, currencyFilterMixin],
  data() {
    return {
      currentStep: 0,
      currentPaymentTypeSelected: null,
      paymentTypeSelectedAction: () => {},
      hideButtonActionPayment: true,
      hideNextStep: false,
      hideReturnStepPayment: false,
      specialCreditCardStep: false,
      steps: [
        {
          title: this.$t('steps.titles[0]'),
        },
        {
          title: this.$t('steps.titles[1]'),
        },
        {
          title: this.$t('steps.titles[2]'),
        },
      ],
      stepsData: {
        identify: {
          full_name: null,
          telephone: null,
          email: null,
        },
        shipping: {
          postal_code: null,
          city: null,
          street: null,
          number: null,
          neighborhood: null,
          state: null,
          complement: null,
        },
        payment: {
          credit_card_number: null,
          name: null,
          document: null,
          credit_card_year: null,
          credit_card_month: null,
          credit_card_cvv: null,
          installments: {},
          recaptcha_response: null,
          recaptcha_attempts: 0,
        },
      },
      labelInstallmentsPrice: null,
      returnStepText: null,
      iconPayment: {
        name: 'local_mall',
        position: 'left',
        type: 'material',
        size: 'xl',
      },
      labelButtonPayment: null,
      iconNext: {
        name: 'chevron_right',
        position: 'right',
        type: 'material',
      },
      disabledNextStep: false,
      hiddenButtonInProgress: false,
      creditCardFlag: '',
      creditCardLastDigits: '',
    }
  },
  computed: {
    ...mapState('Checkout', {
      orderBumpsQuantity: (state) => state.cart.items.bundles[0]?.order_bumps.length,
      installmentDefault: (state) => state.cart.items.bundles[0]?.installments_default,
      installments: (state) => state.cart.installments,
      cartStatus: (state) => state.cart,
      loadingGlobal: (state) => state.globalLoading,
      getThemeColor: (state) => state.theme.color,
    }),
  },
  watch: {
    currentStep() {
      if (this.currentStep === 2 && this.$route.name !== 'checkout.stepReviewAddress') {
        this.currentStep = 1
        this.$router.push({ name: 'checkout.stepReviewAddress', query: { step: this.currentStep } })
      }

      if (
        this.currentStep === 2 &&
        this.orderBumpsQuantity !== 0 &&
        !this.hasOrderBumpBeenSelected()
      ) {
        this.handleButtonsFoPaymentOfferCard()
        this.$router.push({
          name: 'checkout.stepPaymentCardOffer',
          query: { step: this.currentStep },
        })
      }

      if (this.hasOrderBumpBeenSelected() && this.currentStep === 1) {
        this.continueToPaymentType()
      }

      this.disabledButtonPaymentTypeSelected()

      if (this.currentStep === 2 && this.$route.name === 'checkout.stepReviewAddress') {
        this.disabledNextStep = false
        this.$router.push({ name: 'checkout.stepPayment', query: { step: this.currentStep } })
      }
    },
    paymentTypeSelectedComponent() {
      this.getCurrentStepStatus()
      if (this.$route.name === 'checkout.stepPaymentCard') {
        this.paymentCardSetLabel()
      }
    },
    currentPaymentTypeSelected() {
      if (this.currentPaymentTypeSelected) {
        this.disabledNextStep = false
      }
    },
    stepsData: {
      immediate: true,
      deep: true,
      async handler() {
        if (this.$route.name === 'checkout.stepPaymentCard') {
          if (this.stepsData.payment.installments.label) {
            this.paymentSelected('card')
          } else {
            setTimeout(() => {
              if (this.installments.length) {
                this.paymentCardSetLabel()
              }
            }, 5000)
          }
        }
      },
    },
    cartStatus: {
      immediate: true,
      deep: true,
      async handler() {
        const { full_name: fullName, telephone } = this.cartStatus.customer
        let { email } = this.cartStatus.customer

        if (email && !this.cartStatus.settings.email_required) {
          email = email.slice(email.indexOf('@')).includes('appmax') ? '' : email
        }

        this.stepsData.identify = { full_name: fullName, telephone, email }
        if (this.cartStatus.customer.postcode) {
          const {
            postcode,
            address_city: city,
            address_street: street,
            address_street_number: number,
            address_street_district: neighborhood,
            address_state: state,
            address_street_complement: complement,
          } = this.cartStatus.customer

          this.stepsData.shipping = {
            postal_code: postcode,
            city,
            street,
            number,
            neighborhood,
            state,
            complement,
          }
        }

        if (this.cartStatus.recaptcha_attempts) {
          this.stepsData.payment.recaptcha_attempts = this.cartStatus.recaptcha_attempts
        }
      },
    },
    loadingGlobal() {
      if (this.loadingGlobal) {
        this.disabledNextStep = true
        return this.loadingGlobal
      }

      this.disabledNextStep = false
      return this.loadingGlobal
    },
    getThemeColor: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.hiddenButtonInProgress = true
        } else {
          this.hiddenButtonInProgress = false
        }
      },
    },
    $route: {
      handler() {
        let { step } = this.$router.currentRoute.query
        step = Number(step)
        if (step) {
          if (step === 0) {
            this.currentStep = 0
            this.hideNextStep = false
          }
          if (step === 1) {
            this.currentStep = step
            this.hideNextStep = false
          }
          if (step === 2) {
            if (this.currentPaymentTypeSelected === 'card' && this.$refs.defaultCheckoutButton) {
              this.specialCreditCardStep = true
              if (this.$refs.defaultCheckoutButton.styles.display) {
                this.$nextTick(() => {
                  this.$refs.defaultCheckoutButton.styles.display = 'none'
                })
              }

              return
            }

            if (this.orderBumpsQuantity > 0 && this.$refs.defaultCheckoutButton) {
              this.specialCreditCardStep = true
              if (this.$refs.defaultCheckoutButton.styles.display) {
                this.$nextTick(() => {
                  this.$refs.defaultCheckoutButton.styles.display = 'none'
                })
              }
              return
            }

            this.specialCreditCardStep = false
            this.hideNextStep = false
            this.currentStep = step
          }
          if (step === 2 && this.$route.name.includes('/pagamento-')) {
            if (this.currentPaymentTypeSelected === 'card' && this.$refs.defaultCheckoutButton) {
              this.specialCreditCardStep = true
              if (this.$refs.defaultCheckoutButton.styles.display) {
                this.$nextTick(() => {
                  this.$refs.defaultCheckoutButton.styles.display = 'none'
                })
              }
              return
            }

            this.specialCreditCardStep = false
            this.hideNextStep = true
            this.hideReturnStepPayment = false
          }
        } else {
          this.currentStep = 0
          this.hideNextStep = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions('Checkout', [
      'identify',
      'shipping',
      'fetchCep',
      'paymentBillet',
      'paymentCreditCard',
      'paymentPix',
      'states',
      'createOrder',
      'fetchCart',
    ]),
    ...mapMutations('Checkout', ['SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE']),
    disabledButtonPaymentTypeSelected() {
      if (this.$route.name === 'checkout.stepPayment' && this.currentStep === 2) {
        if (this.currentPaymentTypeSelected) {
          this.disabledNextStep = false
        } else {
          this.disabledNextStep = true
        }
      }
    },
    paymentCardSetLabel() {
      this.installments.map((installments) => {
        if (installments.installment === this.installmentDefault) {
          this.stepsData.payment.installments = {
            label: `${installments.installment}x de ${this.$options.filters.currencyBRL(
              installments.value
            )}`,
            id: this.installmentDefault,
          }
        }
        return installments
      })
    },
    paymentSelected(payment) {
      this.currentPaymentTypeSelected = payment
      const paymentAction = {
        creditcard: () => this.paymentForCreditCard(),
        card: () => this.paymentForCreditCard(),
        billet: () => this.paymentForBillet(),
        pix: () => this.paymentForPix(),
      }

      const paymentButtonIcon = {
        creditcard: 'local_mall',
        card: 'local_mall',
        billet: 'view_week',
        pix: 'pix',
      }

      const labelButtonPayment = {
        creditcard: this.$t('steps.actionsLabels[0]'),
        card: this.$t('steps.actionsLabels[0]'),
        billet: this.$t('steps.actionsLabels[1]'),
        pix: this.$t('steps.actionsLabels[2]'),
      }

      this.paymentTypeSelectedAction = paymentAction[payment]
      this.iconPayment.name = paymentButtonIcon[payment]
      this.labelButtonPayment = labelButtonPayment[payment]
    },
    paymentSelectedComponent(payment) {
      const paymentTypes = {
        creditcard: 'checkout.stepPaymentCard',
        card: 'checkout.stepPaymentCard',
        billet: 'checkout.stepPaymentBillet',
        pix: 'checkout.stepPaymentPix',
        step: 'checkout.stepPayment',
      }

      if (this.orderBumpsQuantity === 0 && paymentTypes[payment] === 'PaymentCardOffer') {
        this.$router.push({ name: 'checkout.stepPaymentCard', query: { step: this.currentStep } })
        this.hideNextStep = true
        return true
      }

      const componentToCall = paymentTypes[payment] || paymentTypes.step

      this.$router.push({ name: componentToCall, query: { step: this.currentStep } })
      this.hideNextStep = true
      return payment
    },
    continueToPaymentType() {
      this.hideNextStep = false
      this.disabledNextStep = false
      this.hideButtonActionPayment = true
      this.hideReturnStepPayment = false
      this.$router.push({ name: 'checkout.stepPayment', query: { step: this.currentStep } })
    },
    async paymentForCreditCard() {
      try {
        const validate = await this.$refs.routerComponent.validateData()

        if (validate) {
          this.hideButtonActionPayment = false
          this.hideReturnStepPayment = true
          await this.paymentCardFinishPayment()
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async paymentCardFinishPayment() {
      if (
        this.currentPaymentTypeSelected === 'card' ||
        this.currentPaymentTypeSelected === 'creditcard'
      ) {
        this.$router.push({
          name: 'checkout.stepPaymentCardLoading',
          query: { step: this.currentStep },
        })

        try {
          await this.postCreateOrder()
          await this.postPaymentCard()
        } catch (error) {
          throw new Error(error)
        }
      }

      if (this.currentPaymentTypeSelected === 'billet') {
        try {
          await this.paymentForBillet()
          this.hideButtonActionPayment = false
          this.hideReturnStepPayment = true
        } catch (error) {
          throw new Error(error)
        }
      }

      if (this.currentPaymentTypeSelected === 'pix') {
        try {
          await this.paymentForPix()
          this.hideButtonActionPayment = false
          this.hideReturnStepPayment = true
        } catch (error) {
          throw new Error(error)
        }
      }
    },
    async paymentForBillet() {
      try {
        await this.validateCPFPaymentBilletAndPix()
        await this.postCreateOrder()
        await this.postPaymentBillet()
        this.hideButtonActionPayment = !this.hideButtonActionPayment
        this.hideReturnStepPayment = true
        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    async paymentForPix() {
      try {
        await this.validateCPFPaymentBilletAndPix()
        await this.postCreateOrder()
        await this.postPaymentPix()
        this.hideButtonActionPayment = false
        this.hideReturnStepPayment = true
        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    returnStepShowText() {
      const returnStepText = {
        1: this.$t('steps.returnIndetifyStep'),
        2: this.$t('steps.returnAddressStep'),
        3: this.$t('return'),
      }

      this.returnStepText = returnStepText[this.currentStep]

      if (this.currentStep === 2 && this.$route.name === 'checkout.stepPaymentCard') {
        this.returnStepText = returnStepText['3']
      }

      return this.currentStep > 0
    },
    returnStep() {
      this.disabledNextStep = false
      if (this.currentStep === 2 && this.$route.name === 'checkout.stepPaymentCard') {
        this.$router.push({ name: 'checkout.stepPayment', query: { step: this.currentStep } })
        return true
      }

      if (this.currentStep > 0) {
        this.$refs.steps.previousStep()

        const steps = {
          0: 'checkout.stepData',
          1: 'checkout.stepReviewAddress',
          2: 'checkout.stepPayment',
        }

        const { step } = this.$router.currentRoute.query

        this.$router.push({ name: steps[step - 1], query: { step: step - 1 } })
      }

      return this.currentStep
    },
    returnFromOrderBump() {
      this.hideNextStep = false
      this.disabledNextStep = false
      this.$refs.steps.previousStep()
    },
    hasOrderBumpBeenSelected() {
      return this.cartStatus.items.bundles[1]?.isOrderBump
    },
    handleButtonsFoPaymentOfferCard() {
      this.hideNextStep = true
      this.disabledNextStep = true
      this.hideButtonActionPayment = false
      this.hideReturnStepPayment = true
    },
    returnPaymentType() {
      this.$router.push({ name: 'checkout.stepPayment', query: { step: this.currentStep } })
      this.hideNextStep = false
      this.hideButtonActionPayment = true
      this.hideReturnStepPayment = false
    },
    returnPaymentCardDataPayment() {
      if (
        this.currentPaymentTypeSelected === 'card' ||
        this.currentPaymentTypeSelected === 'creditcard'
      ) {
        this.$router.push({ name: 'checkout.stepPaymentCard', query: { step: this.currentStep } })
      }

      if (this.currentPaymentTypeSelected === 'billet') {
        this.$router.push({ name: 'checkout.stepPaymentBillet', query: { step: this.currentStep } })
      }

      if (this.currentPaymentTypeSelected === 'pix') {
        this.$router.push({ name: 'checkout.stepPaymentPix', query: { step: this.currentStep } })
      }

      this.hideButtonActionPayment = true
      this.hideReturnStepPayment = false
    },
    nextStep() {
      this.$refs.steps.nextStep()
    },
    returnPayment() {
      this.$router.push({ name: 'checkout.stepPayment', query: { step: this.currentStep } })
      this.hideNextStep = false
      this.iconPayment.name = 'local_mall'
      this.hideButtonActionPayment = true
    },
    reviewEditContact() {
      if (this.disabledNextStep) {
        this.disabledNextStep = false
      }
      this.returnStep()
    },
    reviewEditAdress() {
      if (this.disabledNextStep) {
        this.disabledNextStep = false
      }
      this.$router.push({ name: 'checkout.stepAddress', query: { step: this.currentStep } })
    },
    async actionsPostSteps() {
      const actionsPost = {
        0: () => this.postIdentify(),
        1: () => this.postShipping(),
        2: () => this.nextPaymentForEnter(),
        next: () => this.nextStep(),
      }

      if (
        this.currentStep === 1 &&
        (this.$route.name === 'checkout.stepReviewAddress' ||
          this.$route.name === 'checkout.stepPaymentCardOffer')
      ) {
        actionsPost.next()
        return 0
      }

      if (this.currentStep === 2 && this.currentPaymentTypeSelected === 'billet') {
        actionsPost[2] = () => this.postPaymentBillet()
        this.paymentSelectedComponent(this.currentPaymentTypeSelected)
        return this.currentPaymentTypeSelected
      }

      if (
        this.currentStep === 2 &&
        (this.currentPaymentTypeSelected === 'card' ||
          this.currentPaymentTypeSelected === 'creditcard')
      ) {
        actionsPost[2] = () => this.postPaymentCard()
        this.paymentSelectedComponent(this.currentPaymentTypeSelected)
        return this.currentPaymentTypeSelected
      }

      if (this.currentStep === 2 && this.currentPaymentTypeSelected === 'pix') {
        actionsPost[2] = () => this.postPaymentPix()
        this.paymentSelectedComponent(this.currentPaymentTypeSelected)
        return this.currentPaymentTypeSelected
      }

      return (actionsPost[this.currentStep] || actionsPost.next)()
    },
    async nextPaymentForEnter() {
      const actionsEmittedForEnter = {
        'checkout.stepPayment': () => this.$refs.routerComponent.applyerCoupon(),
        'checkout.stepPaymentCard': () => this.paymentForCreditCard(),
        'checkout.stepPaymentBillet': () => this.paymentForBillet(),
        'checkout.stepPaymentPix': () => this.paymentForPix(),
      }

      return actionsEmittedForEnter[this.$route.name]()
    },
    async postIdentify() {
      try {
        const validate = await this.$refs.routerComponent.validateData()
        const telephone = await this.replaceSpecialCharacters(this.stepsData.identify.telephone)
        const { email } = this.stepsData.identify
        const { hash } = this.cartStatus

        if (validate) {
          if (!email) {
            delete this.stepsData.identify.email
          }

          const dataIdentify = {
            ...this.stepsData.identify,
            telephone,
          }

          await this.identify(dataIdentify)
          this.fetchCart(hash)
          this.nextStep()
          this.$router.push({ name: 'checkout.stepAddress', query: { step: this.currentStep } })
        }
        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    async postShipping() {
      try {
        const validate = await this.$refs.routerComponent.validateData()

        if (validate) {
          await this.shipping(this.stepsData.shipping)
          this.nextStep()
        }

        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    async validateCPFPaymentBilletAndPix() {
      try {
        let validate = false

        if (
          this.$route.name === 'checkout.stepPaymentBillet' ||
          this.$route.name === 'checkout.stepPaymentPix'
        ) {
          validate = await this.$refs.routerComponent.validateCPF()
        } else {
          validate = true
        }

        return validate
      } catch (error) {
        throw new Error(error)
      }
    },
    async postPaymentBillet() {
      try {
        const validate = await this.validateCPFPaymentBilletAndPix()

        if (validate) {
          try {
            const cpf = this.replaceSpecialCharacters(this.stepsData.payment.document)
            const {
              data: { data: billetData },
            } = await this.paymentBillet({ document: cpf })

            this.$router.push({
              name: 'checkout.stepPaymentBilletSuccess',
              query: { step: this.currentStep },
            })
            this.stepsData.payment = billetData
            this.nextStep()
            return true
          } catch (error) {
            this.$router.push({
              name: 'checkout.stepPaymentError',
              query: { step: this.currentStep },
            })
            this.hideButtonActionPayment = false
            this.hideReturnStepPayment = true
            throw new Error(error)
          }
        }

        return false
      } catch (error) {
        throw new Error(error)
      }
    },
    async postPaymentCard() {
      try {
        const cpf = this.replaceSpecialCharacters(this.stepsData.payment.document)
        const creditCardNumber = this.replaceSpecialCharacters(
          this.stepsData.payment.credit_card_number
        )

        const { data } = await this.paymentCreditCard({
          ...this.stepsData.payment,
          installments: this.stepsData.payment.installments.id,
          credit_card_number: creditCardNumber,
          document: cpf,
        })

        this.checkCreditCardData(data.data.creditCardDetails)
        this.$router.push({
          name: 'checkout.stepPaymentSuccess',
          query: { step: this.currentStep },
        })
        return true
      } catch (error) {
        this.$router.push({ name: 'checkout.stepPaymentError', query: { step: this.currentStep } })
        this.hideButtonActionPayment = false
        this.hideReturnStepPayment = true
        throw new Error(error)
      }
    },
    async postPaymentPix() {
      try {
        const validate = await this.validateCPFPaymentBilletAndPix()
        if (validate) {
          try {
            const cpf = this.replaceSpecialCharacters(this.stepsData.payment.document)
            const {
              data: { data: pix },
            } = await this.paymentPix({ document: cpf })
            this.$router.push({
              name: 'checkout.stepPaymentPixSuccess',
              query: { step: this.currentStep },
            })
            this.stepsData.payment.pix = pix
            this.nextStep()
          } catch (error) {
            this.$router.push({
              name: 'checkout.stepPaymentError',
              query: { step: this.currentStep },
            })
            this.hideButtonActionPayment = false
            this.hideReturnStepPayment = true
            throw new Error(error)
          }
        }

        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    async getCep(handleFocusToNumberField) {
      try {
        const cep = this.stepsData.shipping.postal_code
        const data = await this.fetchCep(cep)
        this.$refs.routerComponent.disableStateField()

        this.stepsData.shipping.city = data.localidade
        this.stepsData.shipping.state = data.uf
        this.stepsData.shipping.street = data.logradouro
        this.stepsData.shipping.neighborhood = data.bairro

        // CALLBACK ALTERANDO FOCUS
        handleFocusToNumberField(data)

        if (data.erro) {
          this.$refs.routerComponent.statusPostalCodeValidate = 'error'
          this.$refs.routerComponent.textPostalCodeValidate = 'CEP inválido'
          throw new Error('CEP inválido')
        }

        this.$refs.routerComponent.statusPostalCodeValidate = 'success'
        this.$refs.routerComponent.textPostalCodeValidate = ''

        return true
      } catch (error) {
        this.$refs.routerComponent.enableStateField()
        return error
      }
    },
    async postCreateOrder() {
      try {
        const paymentTypes = {
          creditcard: 'CreditCard',
          card: 'CreditCard',
          billet: 'Boleto',
          pix: 'Pix',
        }

        await this.createOrder(paymentTypes[this.currentPaymentTypeSelected])

        return true
      } catch (error) {
        return error
      }
    },
    getCurrentStepStatus() {
      const currentTypePayment =
        this.$route.name === 'checkout.stepPaymentCard' ||
        this.$route.name === 'checkout.stepPaymentBillet' ||
        this.$route.name === 'checkout.stepPaymentPix' ||
        this.$route.name === 'checkout.stepPaymentCardLoading' ||
        this.$route.name === 'checkout.stepPaymentBilletSuccess' ||
        this.$route.name === 'checkout.stepPaymentPixSuccess' ||
        this.$route.name === 'checkout.stepPaymentError' ||
        this.$route.name === 'checkout.stepPaymentSuccess'

      const currentPaymentAndStep = this.currentStep === 2 && currentTypePayment

      if (currentPaymentAndStep) {
        this.SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE(true)
        return true
      }

      return this.SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE(false)
    },
    recaptchaAttemptsCount() {
      this.stepsData.payment.recaptcha_attempts += 1
      this.stepsData.payment.recaptcha_response = null
    },
    checkCreditCardData(creditCardData) {
      this.creditCardFlag = creditCardData.creditCardBrand
      this.creditCardLastDigits = creditCardData.creditCardLastDigits.slice(-4)
    },
  },
}
</script>

<style lang="scss" scoped>
.container__left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  min-height: 100%;
  overflow: auto;
  background: $light-20;
  &__left__card {
    overflow: visible;
  }
  @include mobile {
    width: 100%;
    background: transparent;
    justify-content: flex-start;
  }
  @include tablet {
    width: 100%;
  }
  &__card {
    min-height: 500px;
    background: $white;
    @include mobile {
      min-height: min-content;
      margin-top: 60px;
      width: 100%;
    }
    @include tablet {
      width: 70%;
    }

    @include desktop {
      width: 50%;
      margin: 8% 0 0 0;
    }
  }

  .steps {
    &__change-payment,
    &__return-step {
      margin: 15px 0 0 0;
      text-align: center;
      .steps__change-payment__return,
      .steps__return-step__return {
        cursor: pointer;
      }
    }

    &__return-step {
      margin: 17px 0 22px 0;
    }

    &__payment {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }

    .next {
      &:disabled {
        border: solid $dark-40 1px !important;
        ::v-deep {
          &.button-content .icon .am-icon .am-icon-material {
            color: $dark-40 !important;
            font-size: 20px;
          }
        }
      }
    }
  }

  .link {
    text-decoration: none;
  }
  ::v-deep .am-card {
    overflow: visible !important;
  }
}
.am-card {
  overflow: visible !important;
}
</style>
